import './index.css'
import React, { Component }  from 'react';
export default function Loading() {
    return(
        <div className="loading">
        <img src="https://upload.wikimedia.org/wikipedia/commons/a/ad/YouTube_loading_symbol_3_%28transparent%29.gif" alt="carregamento"></img>        
      </div>
    )

}